import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import className from 'classnames/bind';
import { Apple, CheckCircleFilled, Facebook, Google, Instagram, Tinkoff, Vk } from "../icons";
import { TextBase } from "../internal/TextBase";
import style from './SocialName.css';
var ICONS = {
  apple: /*#__PURE__*/React.createElement(Apple, {
    color: "W100",
    style: {
      transform: 'translateY(-1px)'
    }
  }),
  fb: /*#__PURE__*/React.createElement(Facebook, {
    color: "W100"
  }),
  google: /*#__PURE__*/React.createElement(Google, {
    color: "W100"
  }),
  vk: /*#__PURE__*/React.createElement(Vk, {
    color: "W100"
  }),
  instagram: /*#__PURE__*/React.createElement(Instagram, {
    color: "W100"
  }),
  tinkoff: /*#__PURE__*/React.createElement(Tinkoff, null)
};
var CAPTIONS = {
  apple: 'Apple',
  fb: 'Facebook',
  google: 'Google',
  instagram: 'Instagram',
  vk: 'VKontakte',
  tinkoff: 'Tinkoff'
};
var cx = className.bind(style);

var SocialName = function SocialName(_ref) {
  var name = _ref.name,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'fb' : _ref$type;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('SocialName', _defineProperty({}, "SocialName_".concat(type), type))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Icon', "Icon_".concat(type))
  }, ICONS[type], /*#__PURE__*/React.createElement("div", {
    className: cx('CheckIcon')
  }, /*#__PURE__*/React.createElement(CheckCircleFilled, {
    block: true,
    size: "md"
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('Caption')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "l",
    weight: "semibold"
  }, name), /*#__PURE__*/React.createElement(TextBase, {
    color: "N100"
  }, CAPTIONS[type])));
};

export var types = ['fb', 'vk', 'google', 'instagram', 'apple', 'tinkoff'];
export default SocialName;